//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  is: "アイスランド",
  ie: "アイルランド",
  az: "アゼルバイジャン",
  af: "アフガニスタン",
  us: "アメリカ合衆国",
  ae: "アラブ首長国連邦",
  dz: "アルジェリア",
  ar: "アルゼンチン",
  aw: "アルバ",
  al: "アルバニア",
  am: "アルメニア",
  ai: "アンギラ",
  ao: "アンゴラ",
  ag: "アンティグア・バーブーダ",
  ad: "アンドラ",
  ye: "イエメン",
  gb: "イギリス",
  il: "イスラエル",
  it: "イタリア",
  iq: "イラク",
  ir: "イラン",
  in: "インド",
  id: "インドネシア",
  wf: "ウォリス・フツナ",
  ug: "ウガンダ",
  ua: "ウクライナ",
  uz: "ウズベキスタン",
  uy: "ウルグアイ",
  ec: "エクアドル",
  eg: "エジプト",
  ee: "エストニア",
  sz: "エスワティニ",
  et: "エチオピア",
  er: "エリトリア",
  sv: "エルサルバドル",
  au: "オーストラリア",
  at: "オーストリア",
  ax: "オーランド諸島",
  om: "オマーン",
  nl: "オランダ",
  bq: "オランダ領カリブ",
  gh: "ガーナ",
  cv: "カーボベルデ",
  gg: "ガーンジー",
  gy: "ガイアナ",
  kz: "カザフスタン",
  qa: "カタール",
  ca: "カナダ",
  ga: "ガボン",
  cm: "カメルーン",
  gm: "ガンビア",
  kh: "カンボジア",
  gn: "ギニア",
  gw: "ギニアビサウ",
  cy: "キプロス",
  cu: "キューバ",
  cw: "キュラソー",
  gr: "ギリシャ",
  ki: "キリバス",
  kg: "キルギス",
  gt: "グアテマラ",
  gp: "グアドループ",
  gu: "グアム",
  kw: "クウェート",
  ck: "クック諸島",
  gl: "グリーンランド",
  cx: "クリスマス島",
  gd: "グレナダ",
  hr: "クロアチア",
  ky: "ケイマン諸島",
  ke: "ケニア",
  ci: "コートジボワール",
  cc: "ココス(キーリング)諸島",
  cr: "コスタリカ",
  km: "コモロ",
  co: "コロンビア",
  cg: "コンゴ共和国(ブラザビル)",
  cd: "コンゴ民主共和国(キンシャサ)",
  sa: "サウジアラビア",
  gs: "サウスジョージア・サウスサンドウィッチ諸島",
  ws: "サモア",
  bl: "サン・バルテルミー",
  mf: "サン・マルタン",
  st: "サントメ・プリンシペ",
  zm: "ザンビア",
  pm: "サンピエール島・ミクロン島",
  sm: "サンマリノ",
  sl: "シエラレオネ",
  dj: "ジブチ",
  gi: "ジブラルタル",
  je: "ジャージー",
  jm: "ジャマイカ",
  ge: "ジョージア",
  sy: "シリア",
  sg: "シンガポール",
  sx: "シント・マールテン",
  zw: "ジンバブエ",
  ch: "スイス",
  se: "スウェーデン",
  sd: "スーダン",
  sj: "スバールバル諸島・ヤンマイエン島",
  es: "スペイン",
  sr: "スリナム",
  lk: "スリランカ",
  sk: "スロバキア",
  si: "スロベニア",
  sc: "セーシェル",
  sn: "セネガル",
  rs: "セルビア",
  kn: "セントクリストファー・ネーヴィス",
  vc: "セントビンセント及びグレナディーン諸島",
  sh: "セントヘレナ",
  lc: "セントルシア",
  so: "ソマリア",
  sb: "ソロモン諸島",
  tc: "タークス・カイコス諸島",
  th: "タイ",
  tj: "タジキスタン",
  tz: "タンザニア",
  cz: "チェコ",
  td: "チャド",
  tn: "チュニジア",
  cl: "チリ",
  tv: "ツバル",
  dk: "デンマーク",
  de: "ドイツ",
  tg: "トーゴ",
  tk: "トケラウ",
  do: "ドミニカ共和国",
  dm: "ドミニカ国",
  tt: "トリニダード・トバゴ",
  tm: "トルクメニスタン",
  tr: "トルコ",
  to: "トンガ",
  ng: "ナイジェリア",
  nr: "ナウル",
  na: "ナミビア",
  nu: "ニウエ",
  ni: "ニカラグア",
  ne: "ニジェール",
  nc: "ニューカレドニア",
  nz: "ニュージーランド",
  np: "ネパール",
  nf: "ノーフォーク島",
  no: "ノルウェー",
  hm: "ハード島・マクドナルド諸島",
  bh: "バーレーン",
  ht: "ハイチ",
  pk: "パキスタン",
  va: "バチカン市国",
  pa: "パナマ",
  vu: "バヌアツ",
  bs: "バハマ",
  pg: "パプアニューギニア",
  bm: "バミューダ",
  pw: "パラオ",
  py: "パラグアイ",
  bb: "バルバドス",
  ps: "パレスチナ自治区",
  hu: "ハンガリー",
  bd: "バングラデシュ",
  pn: "ピトケアン諸島",
  fj: "フィジー",
  ph: "フィリピン",
  fi: "フィンランド",
  bt: "ブータン",
  bv: "ブーベ島",
  pr: "プエルトリコ",
  fo: "フェロー諸島",
  fk: "フォークランド諸島",
  br: "ブラジル",
  fr: "フランス",
  bg: "ブルガリア",
  bf: "ブルキナファソ",
  bn: "ブルネイ",
  bi: "ブルンジ",
  vn: "ベトナム",
  bj: "ベナン",
  ve: "ベネズエラ",
  by: "ベラルーシ",
  bz: "ベリーズ",
  pe: "ペルー",
  be: "ベルギー",
  pl: "ポーランド",
  ba: "ボスニア・ヘルツェゴビナ",
  bw: "ボツワナ",
  bo: "ボリビア",
  pt: "ポルトガル",
  hn: "ホンジュラス",
  mh: "マーシャル諸島",
  mg: "マダガスカル",
  yt: "マヨット",
  mw: "マラウイ",
  ml: "マリ",
  mt: "マルタ",
  mq: "マルティニーク",
  my: "マレーシア",
  im: "マン島",
  fm: "ミクロネシア連邦",
  mm: "ミャンマー (ビルマ)",
  mx: "メキシコ",
  mu: "モーリシャス",
  mr: "モーリタニア",
  mz: "モザンビーク",
  mc: "モナコ",
  mv: "モルディブ",
  md: "モルドバ",
  ma: "モロッコ",
  mn: "モンゴル",
  me: "モンテネグロ",
  ms: "モントセラト",
  jo: "ヨルダン",
  la: "ラオス",
  lv: "ラトビア",
  lt: "リトアニア",
  ly: "リビア",
  li: "リヒテンシュタイン",
  lr: "リベリア",
  ro: "ルーマニア",
  lu: "ルクセンブルク",
  rw: "ルワンダ",
  ls: "レソト",
  lb: "レバノン",
  re: "レユニオン",
  ru: "ロシア",
  io: "英領インド洋地域",
  vg: "英領ヴァージン諸島",
  kr: "韓国",
  um: "合衆国領有小離島",
  eh: "西サハラ",
  gq: "赤道ギニア",
  tw: "台湾",
  cf: "中央アフリカ共和国",
  mo: "中華人民共和国マカオ特別行政区",
  hk: "中華人民共和国香港特別行政区",
  cn: "中国",
  tl: "東ティモール",
  za: "南アフリカ",
  ss: "南スーダン",
  aq: "南極",
  jp: "日本",
  gf: "仏領ギアナ",
  pf: "仏領ポリネシア",
  tf: "仏領極南諸島",
  vi: "米領ヴァージン諸島",
  as: "米領サモア",
  mk: "北マケドニア",
  mp: "北マリアナ諸島",
  kp: "北朝鮮",
};
